module.exports = __webpack_public_path__ + "static/media/scholarship-3.eb30d364.jpg";